var _rect, _rect2, _rect3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHighTem(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 15,
    viewBox: "0 0 8 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2.77496,
    y: 0.349976,
    width: 2.425,
    height: 10.125,
    rx: 1.2125,
    fill: "#D9D9D9",
    stroke: "#FFC354",
    strokeWidth: 0.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 3.02496,
    y: 4.45001,
    width: 1.925,
    height: 5.775,
    rx: 0.9625,
    fill: "#FFC354"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 0.849976,
    y: 8.04999,
    width: 6.275,
    height: 6.275,
    rx: 3.1375,
    fill: "#FFC354",
    stroke: "#FFC354",
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHighTem);
export default __webpack_public_path__ + "static/media/high_tem.eeb121732f0ce6f6f5a8d2a611258210.svg";
export { ForwardRef as ReactComponent };